export interface GoalI {
  id: string;
  goal: string;
  date: string;
}
